import React from 'react'
import { serverForImages } from '../../config'

interface IEmbeddedVideoItemProps {
  fileUrl: string
}

const EmbeddedVideoItem: React.FC<IEmbeddedVideoItemProps> = ({ fileUrl }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: fileUrl }}>

    </div>
  )
}

export default EmbeddedVideoItem
